export const UPDATE_CASH_REGISTERS = 'cash/UPDATE_CASH_REGISTERS'
export const UPDATE_CASH_REGISTER_BY_ID = 'cash/UPDATE_CASH_REGISTER_BY_ID'
export const UPDATE_CASH_AMOUNT = 'cash/UPDATE_CASH_AMOUNT'
export const IS_LOADING = 'cash/IS_LOADING'
